import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectedGoodieProductsSelector, countOfSelectedGoodieProductsSelector, formattedTotalPriceOfSelectedGoodieProductsSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-selection.selectors';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { REMOVE_SELECTED_GOODIE_PRODUCT_POPUP } from 'swag-client-common/constants';
import { changeQuantity } from 'swag-client-common/redux/goodie-giveaway/actions/goodie-giveaway-selection.actions';
import { giveawayLinkRouteSelector, selectedGiveawayColorWithFallbackSelector, selectedGiveawayTypeSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { CheckoutProductsListComponent } from './checkout-products-list';
const mapStateToProps = createStructuredSelector({
  products: selectedGoodieProductsSelector,
  total: formattedTotalPriceOfSelectedGoodieProductsSelector,
  itemsNumber: countOfSelectedGoodieProductsSelector,
  link: giveawayLinkRouteSelector,
  giveawayType: selectedGiveawayTypeSelector,
  numbersColor: selectedGiveawayColorWithFallbackSelector
});
const mapDispatchToProps = dispatch => ({
  onDeleteProduct: (product, link) => {
    dispatch(showPopup({
      popup: REMOVE_SELECTED_GOODIE_PRODUCT_POPUP,
      product,
      link
    }));
  },
  onQuantityChange: (productId, quantity, link) => {
    dispatch(changeQuantity(productId, quantity, link));
  }
});
export const CheckoutProductsList = connect(mapStateToProps, mapDispatchToProps)(CheckoutProductsListComponent);